import React from "react";
import TicTacToe from "./components/TicTacToe/TicTacToe";
// import Counter from "./components/Counter/Counter";
// import Parent from "./components/ParentChild/Parent/Parent";
// import Fetch from "./components/Fetch/Fetch";
// import TicTacToeAdvanced from "./components/TicTacToeAdvanced/TicTacToeAdvanced";

function App() {

  return (
    <TicTacToe />
    // <Counter />
    // <Parent />
    // <Fetch />
    // <TicTacToeAdvanced noOfSquares={25} />
  );
}

export default App;
